import Vue from 'vue';
import VueI18n from 'vue-i18n';
import fr from './locale/fr.json';

export const translations = { fr };

Vue.use(VueI18n);

export const RTL_LANGUAGES = ['ar', 'he'];

export const languages = [
    { text: 'Français', value: 'fr' },
];

if (!localStorage.getItem('language')) {
    localStorage.setItem('language', 'fr');
}

const locale = 'fr';


const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: 'fr',
    messages: translations,
});

Vue.prototype.i18n = i18n;

export default i18n;
